import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=807e0302&"
import script from "./Fees.vue?vue&type=script&lang=js&"
export * from "./Fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports